import { useDispatch as useDispatchBase, useStore } from 'react-redux'

import type { AppDispatch } from '@redux/store'

// @ts-expect-error TS2554
const useDispatch = () => useDispatchBase<AppDispatch>(useStore().dispatch)

export default useDispatch
